<ng-template #content><ng-content /></ng-template>

@switch (level()) {
  @case ('h1') {
    <h1 cmHeading [level]="visualLevel() ?? level()">
      <ng-container [ngTemplateOutlet]="content" />
    </h1>
  }
  @case ('h2') {
    <h2 cmHeading [level]="visualLevel() ?? level()">
      <ng-container [ngTemplateOutlet]="content" />
    </h2>
  }
  @case ('h3') {
    <h3 cmHeading [level]="visualLevel() ?? level()">
      <ng-container [ngTemplateOutlet]="content" />
    </h3>
  }
  @case ('h4') {
    <h4 cmHeading [level]="visualLevel() ?? level()">
      <ng-container [ngTemplateOutlet]="content" />
    </h4>
  }
}
